import React from 'react';

export const inp: React.CSSProperties = {
  width: '100%', padding: '8px 10px', background: 'var(--surface2)',
  border: '1.5px solid var(--border2)', borderRadius: 9, color: 'var(--text)',
  fontFamily: 'var(--font)', fontSize: 13, outline: 'none', boxSizing: 'border-box',
};

export const sel: React.CSSProperties = { ...inp, cursor: 'pointer', height: 38 };

export const lbl: React.CSSProperties = {
  display: 'block', fontSize: 12, fontWeight: 500,
  color: 'var(--text2)', marginBottom: 4,
};

export function MsgBox({ msg }: { msg: string }) {
  if (!msg) return null;
  const isSuccess = msg.startsWith('✓');
  return (
    <div style={{
      fontSize: 11, padding: '6px 10px', marginBottom: 10, borderRadius: 6,
      background: isSuccess ? 'var(--accent-bg)' : 'var(--red-bg)',
      color: isSuccess ? 'var(--accent)' : 'var(--red)',
    }}>{msg}</div>
  );
}

export function useFlash() {
  return (setter: (m: string) => void, msg: string) => {
    setter(msg);
    setTimeout(() => setter(''), 4000);
  };
}
